::ng-deep particle-add-board-dialog{width:100%}
/*# sourceMappingURL=add-board-dialog.component-7GIKBOBP.css.map */
